import { convertTextToKebabCase } from "@app/shared/utility/convertTextToKebabCase";
import React from "react";
import { ProviderBadgeStyle } from "@app/projects/enumerators";
import { QesColors } from "@app/shared/qes-standards/colors";

export enum BadgeLocation {
    Left = "left",
    Right = "right",
}

interface BadgedContentProps {
    additionalClassName?: string;
    badgeStyle: ProviderBadgeStyle;
    color?: QesColors;
    hideWhenNull?: boolean;
    location?: BadgeLocation;
    text: string;
}

const getColorKeySlug = (color: QesColors): string => {
  const entry = Object.entries(QesColors).find(([, value]) => value === color);
  return entry ? convertTextToKebabCase(entry[0]).replace(/([a-z])(\d)/g, "$1-$2") : "";
};

const BadgedContent: React.FC<BadgedContentProps> = ({ text, badgeStyle, additionalClassName, color, location = BadgeLocation.Left, hideWhenNull = false }) => {
  if (!text && hideWhenNull) {
    return;
  }

  const colorSlug = color ? getColorKeySlug(color) : "";
  const outlineColorClass = colorSlug ? ` badged-content-outline-${colorSlug}` : "";
  const dotColorClass = colorSlug ? ` badged-content-dot-${colorSlug}` : "";
  const locationClass = location === BadgeLocation.Right ? " badged-content-right" : "";
  const extraClass = additionalClassName ? ` ${additionalClassName}` : "";

  return (
      <>
          {badgeStyle === ProviderBadgeStyle.Outline &&
              <div className={`badged-content-outline${outlineColorClass}${locationClass}${extraClass}`}>
                  <span className={`badged-content-outline-circle${outlineColorClass}`} />
                  <span>{text}</span>
              </div>
          }
          {badgeStyle === ProviderBadgeStyle.Dot &&
              <div className={`badged-content-dot${dotColorClass}${locationClass}${extraClass}`}>
                  <span className={`badged-content-dot-circle${dotColorClass}`} />
                  <span>{text}</span>
              </div>
          }
      </>
  )
};

export default BadgedContent;
